export const QA_RULES = {
  // firstAA and lastAA
  QA_RULE_COVERAGE: {
    PR: [30, 90],
    RT: [65, 215],
    IN: [66, 263],
    CA: [57, 183],
  },
  // numStops + numIndels + numAmbiguities + numFrameShifts
  QA_RULE_SEQUENCE_QUALITY: {
    PR: 2, RT: 4, IN: 3, CA: 7,
  },
  // numAPOBECs
  QA_RULE_APOBECS: {
    PR: 2, RT: 3, IN: 3, CA: 4,
  },
  // numUnusualMutations
  QA_RULE_UNUSUAL_MUTATIONS: {
    PR: 8, RT: 15, IN: 10, CA: 6
  },
};

export function QAAbnormalIssue(gene) {
  const threshold = QA_RULES.QA_RULE_SEQUENCE_QUALITY[gene.gene];
  const issueNum = QAAbnormalNum(gene);
  if (issueNum <= threshold) {
    return false;
  } else {
    return true;
  }
}

export function QAAbnormalNum(gene) {
  return (
    QAIndelNum(gene)
    + QAStopNum(gene)
    + QAAmbiguousNum(gene)
  );
}

export function QAAbnormal(gene) {
  let mutations = [];
  mutations = mutations.concat(QAIndel(gene));
  mutations = mutations.concat(QAStop(gene));
  mutations = mutations.concat(QAAmbiguous(gene));
  if (mutations.length > 0) {
    console.log(mutations);

  }
  return mutations;
}

function QAIndel(gene) {
  let mutations = gene.mutations;
  const [minPos, maxPos] = QA_RULES.QA_RULE_COVERAGE[gene.gene];
  mutations = mutations
    .filter(({isIndel}) => isIndel)
    .filter(({position: pos}) => !(pos < minPos || pos > maxPos))
    .filter(({position: pos}) => !(gene === 'RT' && pos > 65 && pos < 72));

  return mutations;
}

function QAIndelNum(gene) {
  const mutations = QAIndel(gene);
  return mutations.length;
}

function QAStop(gene) {
  let mutations = gene.mutations;
  const [minPos, maxPos] = QA_RULES.QA_RULE_COVERAGE[gene.gene];
  mutations = mutations
    .filter(({hasStop}) => hasStop)
    .filter(({position: pos}) => !(pos < minPos || pos > maxPos));

  return mutations;
}

function QAStopNum(gene) {
  const mutations = QAStop(gene);
  return mutations.length;
}

function QAAmbiguous(gene) {
  let mutations = gene.mutations;
  const [minPos, maxPos] = QA_RULES.QA_RULE_COVERAGE[gene.gene];
  mutations = mutations
    .filter(({AAs}) => AAs === 'X' || AAs.split('_', 2)[0].length > 3)
    .filter(({position: pos}) => !(pos < minPos || pos > maxPos));

  return mutations;
}

function QAAmbiguousNum(gene) {
  const mutations = QAAmbiguous(gene);
  return mutations.length;
}

export function QACoverageIssue(gene) {

  const [maxFirstAA, minLastAA] = QA_RULES.QA_RULE_COVERAGE[gene.gene];
  const firstAA = gene.firstAA;
  const lastAA = gene.lastAA;

  if (firstAA > maxFirstAA || lastAA < minLastAA) {
    return true;
  } else {
    return false;
  }
}

export function QAApobec(gene) {
  let mutations = gene.mutations;
  mutations = mutations.filter(({isApobecMutation}) => isApobecMutation);

  return mutations;
}

export function QAApobecNum(gene) {
  const mutations = QAApobec(gene);
  return mutations.length;
}

export function QAApobecIssue(gene) {
  const apobecIssueNum = QAApobecNum(gene);
  const threshold = QA_RULES.QA_RULE_APOBECS[gene.gene];
  if (apobecIssueNum <= threshold) {
    return false;
  } else {
    return true;
  }
}

export function QAUnusual(gene) {
  let mutations = gene.mutations;
  mutations = mutations.filter(({isUnusual}) => isUnusual);
  return mutations;
}

export function QAUnusualNum(gene) {
  const mutations = QAUnusual(gene);
  return mutations.length;
}

export function QAUnusualIssue(gene) {
  const unusualIssueNum = QAUnusualNum(gene);
  const threshold = QA_RULES.QA_RULE_UNUSUAL_MUTATIONS[gene.gene];
  if (unusualIssueNum <= threshold) {
    return false;
  } else {
    return true;
  }
}

export function hasQAIssue(gene) {
  return (
    QAAbnormalIssue(gene)
    || QACoverageIssue(gene)
    || QAUnusualIssue(gene)
    || QAApobecIssue(gene));
}

export function getDRMutations(gene) {
  const {mutations: muts} = gene;
  return (
    (muts || []).filter(
      ({primaryType}) => (
        primaryType !== 'Other'
      )
    )
  );
}

export function getOtherMutations(gene) {
  const {mutations: muts} = gene;
  return (
    (muts || []).filter(
      ({primaryType}) => (
        primaryType === 'Other'
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/utils/QA.js